import { AppLogger } from '~/lib/utils';
import { debounce } from 'lodash-es';
import { TRACKING_EVENTS } from '~/lib/constants';

type TrackingEvent = keyof typeof TRACKING_EVENTS | (typeof TRACKING_EVENTS[keyof typeof TRACKING_EVENTS] & string) | string;

export function useGTM () {
  const triggerEvent = debounce((event: TrackingEvent, payload: Record<any, any> | any = {}) => {
    const dataLayerData = {
      event,
      payload,
    };

    AppLogger('[dataLayer]', dataLayerData);
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerData);
    }
  }, 90);

  return {
    triggerEvent,
  };
}
